var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9995 9.00868L25.3329 11.6753V5.33268H13.3329V11.9993H6.66621V26.666H25.3329V22.99L27.9995 20.3233V28.01C27.9992 28.3609 27.8595 28.6974 27.6113 28.9454C27.363 29.1934 27.0265 29.3327 26.6755 29.3327H5.32354C5.14845 29.3315 4.97531 29.2958 4.81401 29.2276C4.65271 29.1595 4.50641 29.0602 4.38346 28.9356C4.26051 28.8109 4.16333 28.6632 4.09746 28.501C4.03159 28.3387 3.99831 28.1651 3.99954 27.99V10.666L12.0035 2.66602H26.6635C27.3995 2.66602 27.9995 3.27268 27.9995 3.98868V9.00868ZM29.0369 11.742L30.9222 13.6287L20.5515 23.9993L18.6635 23.9967L18.6662 22.114L29.0369 11.7433V11.742Z",
    fill: "#E2B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapel);
export default __webpack_public_path__ + "static/media/papel.e8228c18ed7f65c7e05cb82febdf28d8.svg";
export { ForwardRef as ReactComponent };